


import '../materialDialog/controllers/materialDialogController';
import { MaterialsController } from './controllers/materialsController';
import '../../../../../core/directives/readOnlyText/readOnlyTextDirective';
import '../../models/requestDetailEdit';
import './templates/materials.scss';

export class MaterialsDirective implements angular.IDirective{
    
        template = require('./templates/materials.html');
        controller = MaterialsController;
        controllerAs = "vm";
        bindToController = {
            requestDetailEdit: '=',
            isFormRequestedFromAddNewRequest: '=',
            isValid: "="
        };
        scope = {};
        replace = true;
    static factory(): angular.IDirectiveFactory {
        return () => new MaterialsDirective();
}
}

angular.module('deliveryCreate.app').directive('materials', MaterialsDirective.factory());



/** WEBPACK FOOTER **
 ** ./DeliveryCreate/UI/app/features/request/requestDetailEdit/directives/materials/materialsDirective.ts
 **/